
import { Component, OnInit, ViewChild, ViewContainerRef, OnDestroy, ElementRef } from '@angular/core';
import { BreadcrumbComponent } from '../../../breadcrumb/breadcrumb.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ADOpportunityByPartnerCSNAndDateRange, Message, LineItems } from '../../../models/ad-opportunity.model';
import { Subscription, Subject } from 'rxjs';
import { CommonService } from '../../../services';
import { TransactOpportunityInput, EndCustomer, ShipTo, Reseller, Account, ContractManager, SoldTo, LineItemObj, TransactOpportunityModel } from '../../../models/transactOpportunity.model';
import { DatePipe } from '@angular/common';
import { Sort } from '@angular/material/sort';
import { TablefilterMultiplePipe } from '../../../shared/pipes/tablefilter-multiple.pipe';
import { AnnuityListViewModel } from '../../../models/annuity-view.model';
import { ManageService } from '../../../services/manage.service';
import { NgProgressService } from '../../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';
import { ApiResponse } from '../../../models/api-response.model';
import { ConfirmAutodeskSwitchComponent } from '../../../popup-collection/confirm-autodesk-switch/confirm-autodesk-switch.component';
import { QuoteListReponse } from '../../../models/quote.model';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { AuthService } from '../../../services/auth.service';
import { FileService } from '../../../services/file.service';

declare var $: any;

@Component({
  selector: 'manage-ltedetails',
  templateUrl: './manage-ltedetails.component.html',
  styleUrls: ['./manage-ltedetails.component.css']
})
export class ManageLtedetailsComponent implements OnInit, OnDestroy {

  title: string;

  searchField = '';
  switchTo = '';
  loadContent = false;
  totalPrice: number = 0.00;

  enablePurchase: boolean = true;
  responseMsg: any;

  hideFirstLevel = false;

  adOpportunityDetail: ADOpportunityByPartnerCSNAndDateRange;
  adOpportunityDetailSubscription: Subscription;

  transactOpportunitySubscription: Subscription;
  transactOpportunity: TransactOpportunityModel;

  messages: Message[] = [];
  lineitems: LineItems[] = [];
  sortedData: LineItems[];

  transactOpportunityIn: TransactOpportunityInput;
  end_customer: EndCustomer;
  ship_to: ShipTo;
  reseller: Reseller;
  account: Account;
  contract_manager: ContractManager;
  soldTo: SoldTo;
  line_items: Array<LineItemObj> = [];
  date = new Date();
  currentDate: string;
  partnerCSN: string;
  partnerName: string;
  opportunityID: string;
  poReference: string;
  contractNum: string;

  adOpportunityDetailLoadingStatus: boolean = true;

  renewloadingStatus: boolean = false;

  hasResult = false;
  filterResultArr: any;
  pageView = 'PROGRAMS';
  expiryStart = '';
  expiryEnd = '';

  programLogo = '';

  downloadSub$: Subscription;
  // unsubscribe
  ngUnsubscribe: Subject<void> = new Subject<void>();

  public disableTermSwitch = false;

  // flag for if the check for an existing quote has been completed
  quoteCheck = false;
  quoteId = '';
  quoteVersion = '';
  quoteExpiry = '';

  currentUserModel: CurrentUserModel;
  isStaffAccount = false;

  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent;
  @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
  @ViewChild("ParentWrapper", { static: true }) parentWrapper: ElementRef;

  constructor(
    private router: Router,
    private activeRouter: ActivatedRoute,
    private manageService: ManageService,
    public ngProgress: NgProgressService,
    private commonService: CommonService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private authService: AuthService,
    private fileService: FileService,
  ) {
    this.currentDate = this.datePipe.transform(this.date, 'yyyy-MM-dd');
    this.transactOpportunityIn = new TransactOpportunityInput();
    this.end_customer = new EndCustomer();
    this.ship_to = new ShipTo();
    this.reseller = new Reseller();
    this.account = new Account();
    this.contract_manager = new ContractManager();
    this.soldTo = new SoldTo();

  }

  sortData(sort: Sort) {
    const data = this.lineitems.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }
    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'serialNum': return compare(a.serial_number.toLowerCase(), b.serial_number.toLowerCase(), isAsc);
        case 'description': return compare(a.sku_description.toLowerCase(), b.sku_description.toLowerCase(), isAsc);
        case 'depolyment': return compare(a.deployment.toLowerCase(), b.deployment.toLowerCase(), isAsc);
        case 'rrp': return compare(parseInt(a.rrp_price), parseInt(b.rrp_price), isAsc);
        case 'unitPrice': return compare(parseInt(a.unit_price), parseInt(b.unit_price), isAsc);
        case 'qty': return compare(parseInt(a.quantity), parseInt(b.quantity), isAsc);

        default: return 0;
      }
    });
  }

  ngOnInit() {
    this.ngProgress.start();

    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
      this.isStaffAccount = this.currentUserModel.isStaffAccount;
    },
      (error: any) => {
        console.info(error);
      });

    this.adOpportunityDetailLoadingStatus = true;
    this.manageService.currentContractWatch.subscribe(data => this.contractNum = data);
    this.activeRouter.paramMap.subscribe(query => {
      this.quoteId = '';
      this.quoteVersion = '';
      this.quoteExpiry = '';
      this.loadContent = false;
      this.opportunityID = query.get('opportunityId');
      this.title = `${this.opportunityID} Details`;
      // check if a quote exists
      this.manageService.checkForQuote(this.opportunityID, this.currentUserModel.accountId).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((result: QuoteListReponse) => {
        // result value is the quote itself
        if (result && result.out)
        {
          this.quoteId = result.out[0].out_quote_id;
          this.quoteVersion = result.out[0].out_version;
          this.quoteExpiry = result.out[0].out_expiry_date;       
        }
        this.quoteCheck = true;
      });
      this.activeRouter.parent.paramMap.subscribe(value => {
        this.loadContent = false;
        this.opportunityID = query.get('opportunityId');
        this.title = `${this.opportunityID} Details`;
        this.partnerCSN = value.get('csn');
        this.partnerName = value.get('renewalProgramName');
        if(this.partnerCSN && this.partnerName) {
          $('#levelOne').animate({ scrollLeft: 505 }, 400);
        }

        this.adOpportunityDetailSubscription = this.manageService
          .GetADOpportunityByPartnerCSNAndOpportunityID(this.partnerCSN, this.opportunityID)
          .subscribe((res: ADOpportunityByPartnerCSNAndDateRange) => {
            this.loadContent = true;
            this.adOpportunityDetail = res;
            this.messages = this.adOpportunityDetail.output.message;
            localStorage.setItem("opportunityName", JSON.stringify(this.messages));
            if (this.messages.length) {
              this.title = this.messages[0].accounts.end_customer.account.name;
              this.switchTo = this.messages[0].contract.contract_term === 'Annual' ? '3-Year' : 'Annual';
            }
            this.messages.forEach(message => {
              this.lineitems = message.line_items;
              message.subscription_end_date = this.datePipe.transform(message.subscription_end_date, 'dd/MM/yyyy');
            });
            this.sortedData = this.lineitems.slice();
            this.commonService.applyScrollFixedHeader(this.parentWrapper);
          },
            (error: any) => {
              console.info(error);
              this.ngProgress.done();
            });
      });
    });

    this.manageService.getSubscriptionOrders(this.pageView, 'ADM', this.expiryStart, this.expiryEnd).pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((value: AnnuityListViewModel) => {
        this.programLogo = value.programLogo;
    });

    this.ngProgress.done();
  }

  getRenewList(): void {
    $("#addNewSubscriptionModdal").appendTo("body").modal('show');
    // prepare transactOppotunityInput data
    this.messages.forEach(message => {
      // inital end customer account data
      this.account.csn = message.accounts.end_customer.account.csn;
      this.account.company_name = message.accounts.end_customer.account.name;
      this.account.address_line_1 = message.accounts.end_customer.account.address_line_1;
      this.account.address_line_2 = message.accounts.end_customer.account.address_line_2;
      this.account.address_line_3 = message.accounts.end_customer.account.address_line_3;
      this.account.city = message.accounts.end_customer.account.city;
      this.account.state = message.accounts.end_customer.account.state;
      this.account.postcode = message.accounts.end_customer.account.postal;
      // inital end customer contract manager data
      this.contract_manager.first_name = message.accounts.end_customer.contract_manager.first;
      this.contract_manager.last_name = message.accounts.end_customer.contract_manager.last;
      this.contract_manager.email = message.accounts.end_customer.contract_manager.email;
      this.contract_manager.phone = message.accounts.end_customer.contract_manager.phone;
      // inital shipto data
      this.ship_to.company_name = message.accounts.end_customer.account.name;
      this.ship_to.address_line_1 = message.accounts.end_customer.account.address_line_1;
      this.ship_to.address_line_2 = message.accounts.end_customer.account.address_line_2;
      this.ship_to.city = message.accounts.end_customer.account.city;
      this.ship_to.state = message.accounts.end_customer.account.state;
      this.ship_to.postcode = message.accounts.end_customer.account.postal;
      this.ship_to.csn = message.accounts.end_customer.account.csn;
      // inital Reseller data
      this.reseller.csn = message.accounts.reseller.csn;
      this.reseller.email = '';
      this.reseller.account_code = '';

      // intial soldTo data
      this.soldTo.csn = '';

      // intial line items
      message.line_items.forEach(line_item => {
        let customObj = new LineItemObj();
        customObj.renewal_sku = line_item.renewal_sku;
        customObj.sku_description = line_item.sku_description;
        customObj.serial_number = line_item.serial_number;
        customObj.quantity = line_item.quantity;
        customObj.unit_price = line_item.unit_price;
        this.line_items.push(customObj);
      });

      // instial country code
      if (message.accounts.end_customer.account.country === 'Australia') {
        this.account.country_code = 'AU';
        this.contract_manager.country_code = 'AU';
        this.ship_to.country_code = 'AU';
      } else if (message.accounts.end_customer.account.country === 'New Zealand') {
        this.account.country_code = 'NZ';
        this.contract_manager.country_code = 'NZ';
        this.ship_to.country_code = 'NZ';
      }
      this.transactOpportunityIn.contract_number = message.contract.contract_number;
      this.transactOpportunityIn.opportunity_number = message.opportunity_number;
    });

    // inital end customer
    this.end_customer.account = this.account;
    this.end_customer.contract_manager = this.contract_manager;
    // inital input data
    this.transactOpportunityIn.partner_csn = this.partnerCSN;
    this.transactOpportunityIn.end_customer = this.end_customer;
    this.transactOpportunityIn.ship_to = this.ship_to;
    this.transactOpportunityIn.reseller = this.reseller;
    this.transactOpportunityIn.soldTo = this.soldTo;
    this.transactOpportunityIn.line_items = this.line_items;
  }

  public confirmSwitch(): void {
    this.dialog.open(ConfirmAutodeskSwitchComponent, {
      width: '300px',
      data: {
        title: "Confirm Switch",
        text: `Are you sure to switch to ${this.switchTo}`,
        term: this.switchTo === '3-Year'? '3-Year' : 'Annual',
        list: this.lineitems.map(i => i.serial_number)
      }
    }).afterClosed().subscribe((res : ApiResponse) => {
      if (res && res.status) {
        this.disableTermSwitch = true;
      }
    });
  }

  generateQuote(): void {
    var accountCode = this.currentUserModel.accountId;
    var contactName = this.currentUserModel.firstName + ' ' + this.currentUserModel.lastName;
    var contactEmail = this.currentUserModel.email;

    var adDetailString = JSON.stringify(this.adOpportunityDetail.output);

    this.ngProgress.start();
    this.commonService.implementToast('Autodesk renewal quote will be downloaded shortly', 'Info');
    this.downloadSub$ = this.manageService.createAutodeskQuote(adDetailString, accountCode, contactName, contactEmail, this.quoteId).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      (data: any) => {
        this.quoteId = data.headers.get('X-QuoteId');
        this.quoteVersion = data.headers.get('X-QuoteVersion');
        const fileName = `DDQ${this.quoteId}V${this.quoteVersion}.xlsx`;
        this.fileService.saveAsExcelFile(data.body, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('Autodesk renewal quote downloaded successfully', 'Success');
      }
    );
  }

  downloadQuote(): void {
    this.commonService.implementToast('Autodesk renewal quote will be downloaded shortly', 'Info');
    this.downloadSub$ = this.manageService.downloadQuote(this.quoteId, this.quoteVersion).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(
      (data: any) => {
        const fileName = `DDQ${this.quoteId}V${this.quoteVersion}.xlsx`;
        this.fileService.saveAsExcelFile(data, fileName);
        this.ngProgress.done();
        this.commonService.implementToast('Autodesk renewal quote downloaded successfully', 'Success');
      }
    );
  }

  renew(poReference: string): void {
    if (poReference) {
      this.renewloadingStatus = true;
      this.transactOpportunityIn.partner_po_number = poReference;
      this.transactOpportunityIn.partner_po_date = this.currentDate;
      this.transactOpportunitySubscription = this.manageService
        .GetTransactOpportunity(this.transactOpportunityIn)
        .subscribe((res: TransactOpportunityModel) => {
          this.loadContent = false;
          this.transactOpportunity = res;
          this.loadContent = true;
          this.renewloadingStatus = false;
          this.ngProgress.done();
        },
          (error: any) => {
            console.info(error);
            this.ngProgress.done();
          });
    } else {
      this.commonService.showError(".poReference", "Po reference can not be empty", "right");
    }
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  close() {
    this.ngProgress.done();
    this.router.navigateByUrl('/manageRenewalsNew/renewalsEndUser/upComing/' + this.partnerName + "/" + this.partnerCSN);
    // $('#levelOne').animate({ scrollLeft: 0 }, 400);
  }

  onChange() {
    this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['serial_number', 'sku_description', 'deployment', 'rrp_price', 'unit_price', 'quantity'], this.searchField);
    if (this.filterResultArr.length === 0) {
      this.hasResult = true;

    } else {
      this.hasResult = false;
    }
  }

  filterReset() {
    this.searchField = '';
    this.hasResult = false;
  }

  get shouldCreateNewQuote(): boolean {
    // when there is no quote found
    if (!this.quoteId )
    {
      return true;
    }
    // when a quote is found but the quote is expired
    if (this.quoteExpiry && Date.now() > Date.parse(this.quoteExpiry)) 
    {
      return true;
    }
    
    // when a quote is found and has not expired, should only download the quote
    return false;
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
